awardCalculation.classy.controller({
    name: 'HousingController',
    inject: ['$scope', '$q', 'EditSumsService', 'FamilyThresholdsService', 'RestService','ApplicationService', 'CalculationService', 'HousingService',
    'ModelService', 'BinFactory', 'DateService', 'ResetService', 'CheckListService', 'CalculationService', 'ResetService'],
    init: function()
    {
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$.ResetService = this.ResetService;
    },
    initHomeValues: function()
    {
        this.$.orginalHousing = this.HousingService.getOrignalHousing();
    },
    housingPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var parent = this;
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};

        putDataThresh.Thresh_Housing_Cap = dataThresh.Thresh_Housing_Cap;
        putDataThresh.Thresh_Housing_Percent = dataThresh.Thresh_Housing_Percent;

        putDataEditSums.Rea_Mort_Pay = dataEditSums.Rea_Mort_Pay;
        putDataEditSums.Exp_Rent = dataEditSums.Exp_Rent;
        putDataEditSums.Rea_Property_Tax = dataEditSums.Rea_Property_Tax;
        putDataEditSums.Rea_Home_Ins = dataEditSums.Rea_Home_Ins;
        putDataEditSums.Exp_Home_Ins = dataEditSums.Exp_Home_Ins;

        putDataThresh.familyID = dataThresh.familyID;
        putDataThresh.applicationID = dataEditSums.applicationID;
        putDataEditSums.familyID = dataEditSums.familyID;
        putDataEditSums.applicationID = dataEditSums.applicationID;

            return this.$q.all([
                this.EditSumsService.put(putDataEditSums),
                this.FamilyThresholdsService.put(putDataThresh)
            ]).then(function (data, status, headers, config) {
            parent.CalculationService.reCalc();
            var works = 0;
            if (data[0].status == 200) 
                works++;
            if (data[1].status == 200) 
                works++
            if (works>0)
                instance.stop(1);
            else 
                instance.stop(-1)
        });
    }
});
